import styled from 'styled-components';

export const StyledTicketingWidget = styled.div`
  height: 83vh;
  width: 100%;
`;
